import React from "react";
import { Link } from "react-router-dom";

const LINK_CLASS = "text-brand-accent font-semibold hover:underline underline-offset-2";

export const ConsentBlock = ({ t, checked, onChange }) => (
  <div className="space-y-3 pt-1">
    <label
      data-testid="sms-consent-label"
      className="flex items-start gap-3 cursor-pointer select-none"
    >
      <input
        type="checkbox"
        name="sms_consent"
        checked={checked}
        onChange={onChange}
        data-testid="sms-consent-checkbox"
        className="mt-0.5 h-4 w-4 flex-shrink-0 accent-[color:var(--color-accent)] cursor-pointer"
      />
      <span className="text-xs text-brand-muted leading-relaxed">
        <span className="font-display font-bold text-[10px] uppercase tracking-wider text-brand-accent mr-1.5">
          {t.consent.optional}
        </span>
        {t.consent.sms}
      </span>
    </label>

    <p data-testid="consent-text" className="text-xs text-brand-muted leading-relaxed">
      {t.consent.agreePrefix}
      <Link to="/privacy" data-testid="consent-privacy-link" className={LINK_CLASS}>
        {t.footer.privacy}
      </Link>
      {t.consent.and}
      <Link to="/terms" data-testid="consent-terms-link" className={LINK_CLASS}>
        {t.footer.terms}
      </Link>
      {t.consent.agreeSuffix}
    </p>
  </div>
);
